// Dropdown
(function () {
  $('.js-dropdown').each(function () {
    let $dropdown = $(this),
        $toggle   = $dropdown.find('.js-dropdown-toggle'),
        $content  = $dropdown.find('.js-dropdown-content');

    $toggle.on('click', function (e) {
      e.preventDefault();
      $dropdown.toggleClass('is-active');
      let active = $dropdown.hasClass('is-active');
      $content.attr('aria-hidden', !active);
    });
  });
})();

// GDPR
(function () {
  const GA = 'UA-21442134-1';

  const loadScript = (u, c) => {
    let d = document, t = 'script',
      o = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
    o.src = u;
    if (c) { o.addEventListener('load', function (e) { c(null, e); }, false); }
    s.parentNode.insertBefore(o, s);
  };

  const enableEmbeds = () => {
    Array.from(document.querySelectorAll('iframe[data-src]')).forEach((iframe) => iframe.setAttribute('src', iframe.getAttribute('data-src')));
  };

  const disableEmbeds = () => {
    Array.from(document.querySelectorAll('iframe[data-src]')).forEach((iframe) => iframe.removeAttribute('src'));
  };

  const enableTracking = () => {
    delete window['ga-disable-' + GA];
    if (!window.dataLayer) {
      loadScript('https://www.googletagmanager.com/gtag/js?id=' + GA, () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', GA, { 'anonymize_ip': true });
      });
    }
  };

  const disableTracking = () => {
    window['ga-disable-' + GA] = true;
  };

  window.addEventListener('load', () => {
    cookieconsent.initialise({
      palette: {
        popup: {
          background: '#d2232a',
          text: '#ffffff'
        },
        button: {
          background: '#ffffff',
          text: '#d2232a'
        }
      },
      theme: 'classic', // edgeless
      position: 'bottom-left', // bottom
      type: 'opt-in',
      content: {
        message: 'En poursuivant votre navigation, vous acceptez l’utilisation de services tiers pouvant installer des cookies.',
        dismiss: 'OK',
        allow: 'Accepter',
        deny: 'Refuser',
        link: 'En savoir plus',
        href: '/politique-de-confidentialite/',
        close: '&#x274c;',
        policy: '🍪 Cookies',
        target: '_self',
      },
      revokable: true,
      onInitialise(status) {
        const type = this.options.type;
        const didConsent = this.hasConsented();
        if (type == 'opt-in' && didConsent) {
          enableTracking();
          enableEmbeds();
        }
        if (type == 'opt-out' && !didConsent) {
          disableTracking();
          disableEmbeds();
        }
      },
      onStatusChange(status, chosenBefore) {
        const type = this.options.type;
        const didConsent = this.hasConsented();
        if (type == 'opt-in' && didConsent) {
          enableTracking();
          enableEmbeds();
        }
        if (type == 'opt-out' && !didConsent) {
          disableTracking();
          disableEmbeds();
        }
      },
      onRevokeChoice() {
        const type = this.options.type;
        if (type == 'opt-in') {
          disableTracking();
          disableEmbeds();
        }
        if (type == 'opt-out') {
          enableTracking();
          enableEmbeds();
        }
      }
    }, (popup) => {
      Array.from(document.querySelectorAll('[href="#gdpr"]')).forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          if (popup.isOpen()) {
            popup.setStatus(cookieconsent.status.allow);
            popup.close();
          } else {
            popup.open();
          }
        });
      });
    });
  });
})();

// Header
(function () {
  let $window  = $(window),
      $body    = $('body'),
      $toggles = $('.js-header-toggle');

  $('.js-header').each(function () {
    let $header     = $(this),
        $navigation = $header.find('.js-header-navigation'),
        $menus      = $header.find('.js-header-menu .menu-item-has-children > a'),
        scrollTop   = 0;

    $header.css('position', 'fixed');
    function scroll() {
      $header[$window.scrollTop() > 0 ? 'addClass' : 'removeClass']('is-fixed');
    }
    scroll();
    $window.on('scroll', scroll);

    $navigation.attr('aria-hidden', true);
    $toggles.attr('role', 'button');
    $toggles.attr('aria-expanded', false);
    $toggles.attr('aria-controls', $navigation.attr('id'));

    // Toggles (overlay, navicon…)
    $toggles.on('click', function (e) {
      e.preventDefault();

      $header.toggleClass('is-active');

      let active = $header.hasClass('is-active');

      $navigation.attr('aria-hidden', !active);
      $toggles.attr('aria-expanded', active);

      if (active) {
        scrollTop = $window.scrollTop();
        $body.css('top', '-' + scrollTop + 'px');
        $body.addClass('is-scroll-disabled');
        $window.off('scroll', scroll);
      } else if ($body.hasClass('is-scroll-disabled')) {
        $body.removeClass('is-scroll-disabled');
        window.scrollTo(0, scrollTop);
        $window.on('scroll', scroll);
      }
    });

    // Submenus
    $menus.each(function (index) {
      let $link    = $(this),
          $item    = $link.parent('.menu-item'),
          $submenu = $link.siblings('.sub-menu'),
          id       = $navigation.attr('id') + '-' + index,
          active   = $item.is('[class*="current"]');

      $submenu.attr('id', id);
      $submenu.attr('aria-hidden', !active);

      $link.attr('role', 'button');
      $link.attr('aria-expanded', active);
      $link.attr('aria-controls', id);

      $link.on('click', function (e) {
        e.preventDefault();

        $item.toggleClass($item.is('[class*="current"]') ? 'is-closed' : 'is-open');

        let active = !$item.hasClass('is-closed');

        $submenu.attr('aria-hidden', !active);
        $link.attr('aria-expanded', active);
      });
    });
  });
})();

(function () {
  $('a[rel="lightbox"], a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".gif"]').each(function () {
    var $anchor = $(this),
        type = $anchor.data('type') || 'image';

    if ($anchor.is('[download]')) return;

    $anchor.magnificPopup({
      type: type,
      overflowY: 'scroll'
    });
  });

  $.extend(true, $.magnificPopup.defaults, {
    tClose: '&times;',
    tLoading: '…',
    gallery: {
      tPrev: '‹',
      tNext: '›',
      tCounter: '%curr%/%total%'
    },
    image: {
      tError: '<a href="%url%">L’image</a> n’a pas pu être chargée.'
    },
    iframe: {
      tError: '<a href="%url%">Le contenu</a> n’a pas pu être chargé.'
    }
  });
})();

// Google Maps
(function () {
  function googleMapsLoader (key, callback) {
    var params = [].slice.call(arguments, 2);

    if (window.google && window.google.maps) {
      callback.apply(null, params);
    } else {
      var callbackName = 'callback_' + Math.floor((1 + Math.random()) * 0x10000).toString(16);
      window[callbackName] = function () {
        return callback.apply(null, params);
      };
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://maps.googleapis.com/maps/api/js?callback=' + callbackName + '&key=' + key;
      document.body.appendChild(script);
    }
  }

  let $maps = $('.js-map'),
      $window = $(window);

  // Create maps
  let createMaps = function () {
    $maps.each(function () {
      let $map     = $(this),
          $canvas  = $map.find('.js-map-canvas'),
          $markers = $map.find('.js-map-marker[data-latitude][data-longitude]'),
          map, bounds, infoWindow;

      let latitude  = $canvas.data('latitude'),
          longitude = $canvas.data('longitude');

      // Init map
      map = new google.maps.Map($canvas[0], {
        center: { lat: 0, lng: 0 },
        zoom: 1,
        disableDefaultUI: true,
        disableDoubleClickZoom: false,
        scrollwheel: false,
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL
        }
      });

      bounds = new google.maps.LatLngBounds();

      if (latitude && longitude) {
        bounds.extend({ lat: latitude, lng: longitude });
      }

      infoWindow = new google.maps.InfoWindow();

      // Place markers
      $markers.each(function (index) {
        let $marker   = $(this),
            latitude  = $marker.data('latitude'),
            longitude = $marker.data('longitude'),
            title     = $marker.data('title') || $marker.find('.js-map-title').html(),
            color     = $marker.data('color') || '#000000',
            scale     = $marker.data('scale') || 1,
            detail    = $marker.find('.js-map-detail').html();

        // Create marker
        let position = new google.maps.LatLng(latitude, longitude);
        let marker = new google.maps.Marker({
          position: position,
          title: title,
          icon: {
            path: 'M12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m8.485-12.314C15.8-1.23 8.2-1.23 3.515 3.686-.708 8.114-1.183 16.45 2.4 21.46L12 36l9.6-14.54c3.583-5.01 3.108-13.346-1.115-17.774',
            fillColor: color,
            fillOpacity: 1,
            strokeColor: '#000000',
            strokeOpacity: 0.5,
            strokeWeight: 0.5,
            anchor: new google.maps.Point(12, 36),
            scale: scale
          },
          animation: google.maps.Animation.DROP,
          clickable: !!detail
        });

        // Add to map
        setTimeout(() => marker.setMap(map), index * 50);

        // Register event
        google.maps.event.addListener(marker, 'click', () => {
          infoWindow.setContent(detail);
          infoWindow.open(map, marker);
        });

        // Extend bounds
        bounds.extend(position);
      });

      // Force setZoom to 14 once after fitBounds
      let centerMap = function () {
        google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
          if (map.getZoom() > 14) {
            map.setZoom(14);
          }
        });
        map.fitBounds(bounds);
      };
      centerMap();

      // Trigger map resize on window resize
      google.maps.event.addListener(map, 'resize', () => centerMap());

      $window.on('debouncedresize', (e) => google.maps.event.trigger(map, 'resize'));
    });
  };

  // Create map once only when visible
  if ($maps.length) {
    let checkResize = function (e) {
      let $map = $maps.first();
      if ($map.find('.js-map-canvas').css('display') !== 'none') {
        googleMapsLoader($map.data('key'), createMaps);
        $window.off('debouncedresize', checkResize);
      }
    };
    $window.on('debouncedresize', checkResize);
    checkResize();
  }
})();

// Object fit
(function () {
  if (!!((window.CSS && window.CSS.supports) || window.supportsCSS || false) && CSS.supports('object-fit', 'cover')) return;
  $('img.js-object-fit').each(function () {
    var $img = $(this);
    $img.replaceWith('<div class="' + $img.attr('class') + '" style="background-image: url(' + $img.attr('src') + ');"/>');
  });
})();

// Slideshow
(function () {
  $('.js-slideshow').each(function () {
    let $slideshow = $(this),
        $items     = $slideshow.find('.js-slideshow-item'),
        speed      = $slideshow.data('speed') || 4000,
        current    = 0;

    let interval = setInterval(() => {
      current = (current + 1) % $items.length;
      $items.addClass('is-hidden').eq(current).removeClass('is-hidden');
    }, speed);
  });
})();


// Polyfills (mostly for IE/Edge)
(function () {
   // External SVG
  svg4everybody();

  // Fix iOS 100vh bug (see sources/styles/components/_banner.scss)
  vhCheck('vh-offset');
})();

// Smooth scrolling for anchors
(function () {
  let offset = $('.js-header').outerHeight();

  $('a[href*="#"]:not([href="#"]):not([class*="js-"])').on('click', function() {
    let $anchor = $(this);
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      let $target = $(this.hash);
      $target = $target.length ? $target : $('[name=' + this.hash.slice(1) +']');
      if ($target.length) {
        let top = $target.offset().top;

        if ($anchor.data('center')) {
          top -= Math.max(0, $win.height() / 2 - $target.outerHeight() / 2);
        }

        $('html, body').animate({
          scrollTop: top - offset
        }, 500);
        return false;
      }
    }
  });
})();
